var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from '@max/max';
const isWeb = true;
import { AntiReqTool } from '@nibfe/h5guard-request';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { request as maxRequest } from '@max/meituan-uni-network';
import { getRiskParams } from '@nibfe/mkt-risk-api';
import { getAppVersion, getSystemType, isDianpingAppOrWebview, isMeituanAppOrWebview, isMiniProgramOrWebview, isWeixinMiniProgramOrWeixinWebview, SystemType } from '@nibfe/mkt-env-api';
import { INVALID_CODES, PLAY_TYPE, USER_INFO_VALID_CODE } from '@/types/shared';
import { useLoading } from './useLoading';
import { navigateTo } from "@max/meituan-uni-navigate";
import { getLBSInfo } from '@nibfe/mkt-lbs-api';
export const AJAX_ERROR_NAME = '网络错误';
const API_MAP = {
    PROD: 'https://apihotel.meituan.com',
    // PROD: 'https://ihotel.meituan.com',
    TEST: 'http://api.hotel.test.meituan.com',
    // SL: 'https://zhongyuanchao-utkdq-sl-api.hotel.test.meituan.com',
    SL: 'https://moliyuan02-tvsur-sl-api.hotel.test.meituan.com',
    // IP: 'http://10.171.192.120:8080',
    MOCK: 'http://local.meituan.com:7718',
    PAPI_MOCK: 'https://papi.sankuai.com/api/req/c80c3278-f278-493d-b8c1-4f8048562846'
};
export var API_PATH;
(function (API_PATH) {
    API_PATH["MAIN"] = "/api/play/engine/toc/activity/group/queryGroupInfo";
    API_PATH["JOIN_OR_CREATE_TEAM"] = "/api/play/engine/toc/activity/group/operate";
    API_PATH["RANKING_LIST"] = "/api/play/engine/toc/activity/group/queryGroupBillboard";
    API_PATH["REWARDS"] = "/api/play/engine/toc/reward/query-common";
    API_PATH["INVITE"] = "/api/play/engine/toc/common/invite";
    API_PATH["EXCHANGE_POINTS"] = "/api/play/engine/toc/activity/group/exchangePoint";
    API_PATH["USE_FREE_CARD"] = "/api/play/engine/toc/free/order/card/use";
    API_PATH["CITY_ORDER_TASK"] = "/api/play/engine/toc/activity/group/citySignLottery";
    // 城市下单任务详情
    /** 客态任务接口 */
    API_PATH["ACTIVITY_TASK"] = "/api/play/engine/toc/activity/queryActivityTasks";
    /** 打Call记录接口 */
    API_PATH["CALL_RECORD"] = "/api/play/engine/toc/activity/group/queryInviteRecord";
    /** 参与活动接口（非城市签场景） */
    API_PATH["JOIN_ACTIVITY"] = "/api/play/engine/toc/activity/group/createUserActivityInstance";
    /** 预邀请接口 */
    API_PATH["PRE_INVITE"] = "/api/play/engine/toc/common/preInvite";
    /** 推荐POI接口 */
    API_PATH["RECOMMEND_POI"] = "/landing/page/personalization/rec";
    /** 查询预测城市信息接口 */
    API_PATH["QUERY_PREDICT_CITY_INFO"] = "/landing/page/cityFilter/queryPredictCityInfo";
    /** 更新战队心愿接口 */
    API_PATH["UPDATE_WISH"] = "/api/play/engine/toc/activity/group/updateWish";
})(API_PATH || (API_PATH = {}));
;
export function useRequest(path, options) {
    const { raw = false, showLoading = false, loadingText, method = 'POST' } = options || {};
    const ctx = useMonitorEngineContext();
    const { openLoading, closeLoading } = useLoading();
    const [requestStatus, setRequestStatus] = useState(RequestStatus.SUCCESS);
    const request = (params) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const { uuid, platform, userId, token } = ctx._runtimeInfo.commonParams;
            const isInWxWebview = isWeixinMiniProgramOrWeixinWebview() && !isMiniProgramOrWebview();
            function tryLogin() {
                var _a;
                if (isWeb && isInWxWebview) {
                    const backUrl = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) || '';
                    navigateTo({
                        url: `https://passport.meituan.com/useraccount/ilogin?backurl=${encodeURIComponent(backUrl)}&risk_partner=0&risk_app=-1&risk_platform=3`
                    });
                }
                else {
                    // ctx._userAPI.login()
                }
            }
            if (!userId || !token) {
                tryLogin();
                return;
            }
            setRequestStatus(RequestStatus.LOADING);
            if (showLoading) {
                openLoading(loadingText);
            }
            let finalRequestParams = params;
            if (true) {
                try {
                    const antiReq = new AntiReqTool({
                        autoFillParams: true
                    });
                    // @ts-ignore
                    finalRequestParams = antiReq.addCommonParams(finalRequestParams);
                }
                catch (_c) {
                    ctx._raptorReport.monitorReportLog('请求加上反爬参数错误', '请求加上反爬参数错误', {
                        level: 'warn',
                        category: 'jsError'
                    });
                }
            }
            // const isPtest = true; // TODO: important
            // if (isPtest) { 
            //   finalRequestParams.isPtest = 'true';
            // }
            const riskRequest = yield getRiskRequest(uuid);
            const response = yield new Promise((resolve, reject) => {
                maxRequest({
                    url: `${API_MAP.PROD}${path}`,
                    // url: `${API_MAP.SL}${path}`, //TODO:important
                    data: Object.assign(Object.assign({}, finalRequestParams), { userId: Number(userId), token, platform: platform === 'dp' ? 2 : 1, source: getSource(), riskRequest, playType: PLAY_TYPE }),
                    method,
                    header: {
                        'content-type': 'application/json'
                        // 'isPtest': true //TODO:important
                    },
                    _meituan: {
                        requestType: 'MRNUtils',
                        mrnChannel: 'hotel'
                        // params: finalRequestParams // TODO:important
                    },
                    success(res) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                        (_b = (_a = ctx._raptorReport).monitorReportNetworkSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                            apiPath: path
                        });
                        if (raw) {
                            resolve(res);
                            return;
                        }
                        if (((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.code) === 0 || ((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.status) === 0) {
                            const templateRes = (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.data;
                            resolve(templateRes);
                        }
                        else if (INVALID_CODES.includes((_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.code)) {
                            resolve({
                                uni_status_code: (_g = res === null || res === void 0 ? void 0 : res.data) === null || _g === void 0 ? void 0 : _g.code
                            });
                        }
                        else if (((_h = res === null || res === void 0 ? void 0 : res.data) === null || _h === void 0 ? void 0 : _h.code) === USER_INFO_VALID_CODE) {
                            tryLogin();
                        }
                        else {
                            const error = new Error(AJAX_ERROR_NAME);
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-code非0';
                            let tags = {};
                            try {
                                tags = {
                                    response: JSON.stringify(res),
                                    params: JSON.stringify(finalRequestParams)
                                };
                            }
                            catch (e) { }
                            (_k = (_j = ctx._raptorReport).monitorReportLog) === null || _k === void 0 ? void 0 : _k.call(_j, '接口请求异常', error, {
                                level: 'info',
                                category: 'ajaxError',
                                tags
                            });
                            reject(error);
                        }
                    },
                    fail(error) {
                        var _a, _b, _c, _d;
                        (_b = (_a = ctx._raptorReport).monitorReportNetworkFailed) === null || _b === void 0 ? void 0 : _b.call(_a, {
                            apiPath: path
                        });
                        if (typeof error === 'object') {
                            error.name = AJAX_ERROR_NAME;
                            error.message = '请求接口异常-网络异常';
                        }
                        let tags = {};
                        try {
                            tags = {
                                errorInfo: JSON.stringify(error),
                                params: JSON.stringify(finalRequestParams),
                                apiPath: path
                            };
                        }
                        catch (e) { }
                        (_d = (_c = ctx._raptorReport).monitorReportLog) === null || _d === void 0 ? void 0 : _d.call(_c, '接口请求异常', error, {
                            level: 'info',
                            category: 'ajaxError',
                            tags
                        });
                        reject(error);
                    }
                });
            });
            if (showLoading) {
                closeLoading();
            }
            setRequestStatus(RequestStatus.SUCCESS);
            return response;
        }
        catch (err) {
            if (showLoading) {
                closeLoading();
            }
            setRequestStatus(RequestStatus.ERROR);
            if (err instanceof Error && err.name !== AJAX_ERROR_NAME) {
                let tags = {};
                try {
                    tags = {
                        errorInfo: JSON.stringify(err),
                        params: JSON.stringify(params)
                    };
                }
                catch (e) { }
                (_b = (_a = ctx._raptorReport).monitorReportLog) === null || _b === void 0 ? void 0 : _b.call(_a, err.message, err, {
                    level: 'error',
                    category: 'jsError',
                    tags
                });
            }
            return null;
        }
    });
    return {
        requestStatus,
        request
    };
}
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["LOADING"] = 1] = "LOADING";
    RequestStatus[RequestStatus["SUCCESS"] = 2] = "SUCCESS";
    RequestStatus[RequestStatus["ERROR"] = 3] = "ERROR";
    RequestStatus[RequestStatus["LOADING_MORE"] = 4] = "LOADING_MORE";
    RequestStatus[RequestStatus["LOADING_MORE_SUCCESS"] = 5] = "LOADING_MORE_SUCCESS";
    RequestStatus[RequestStatus["LOADING_MORE_ERROR"] = 6] = "LOADING_MORE_ERROR";
})(RequestStatus || (RequestStatus = {}));
export function getRiskRequest(uuid) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const systemType = getSystemType();
        const isIOS = systemType === SystemType.ios;
        const isAndroid = systemType === SystemType.android;
        let riskRequest = {};
        let location = {};
        try {
            riskRequest = yield getRiskParams(/** 风险标识-酒店 */ 2);
            const locationData = yield getLBSInfo({
                sceneToken: 'mcp_tex_team_ranking_free',
                needLocation: true
            });
            if (((_a = locationData === null || locationData === void 0 ? void 0 : locationData.gpsLocation) === null || _a === void 0 ? void 0 : _a.lng) && ((_b = locationData === null || locationData === void 0 ? void 0 : locationData.gpsLocation) === null || _b === void 0 ? void 0 : _b.lat)) {
                location = {
                    longitude: (_c = locationData === null || locationData === void 0 ? void 0 : locationData.gpsLocation) === null || _c === void 0 ? void 0 : _c.lng,
                    latitude: (_d = locationData === null || locationData === void 0 ? void 0 : locationData.gpsLocation) === null || _d === void 0 ? void 0 : _d.lat
                };
            }
        }
        catch (e) {
            // empty
        }
        const version = getAppVersion();
        return Object.assign(Object.assign(Object.assign({}, riskRequest), { utmMedium: isIOS ? 'iphone' : isAndroid ? 'android' : '', utmCampaign: 'texactivity', utmContent: uuid, utmTerm: version, utmSource: 'meituaninternaltest', versionName: version, sourceType: 'hotel' }), location);
    });
}
export function getSource() {
    return isMeituanAppOrWebview() ? Source.MEITUAN_APP : isDianpingAppOrWebview() ? Source.DIANPING_APP : isWeixinMiniProgramOrWeixinWebview() ? Source.WECHAT_MEITUAN_MINI : Source.MEITUAN_APP;
}
export var Source;
(function (Source) {
    Source[Source["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    // 美团APP
    Source[Source["DIANPING_APP"] = 2] = "DIANPING_APP";
    // 点评APP
    Source[Source["WECHAT_MEITUAN_MINI"] = 3] = "WECHAT_MEITUAN_MINI";
    // 微信美团小程序
    Source[Source["WECHAT_HOTEL_MINI"] = 4] = "WECHAT_HOTEL_MINI";
    // 微信酒店+小程序
    Source[Source["WECHAT_DIANPING_MINI"] = 5] = "WECHAT_DIANPING_MINI"; // 微信点评小程序
})(Source || (Source = {}));
